import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CalendarGrey from "../../assets/img/icons/CalendarGrey.svg";
import CalendarRed from "../../assets/img/icons/CalendarRed.svg";
import CalendarGreen from "../../assets/img/icons/CalendarGreen.svg";

interface ICalendar {
  color: String;
  date: String;
  month: String;
}

const CalendarDiv = (props: ICalendar) => {
  const [date, setDate] = useState(props?.date);
  const [month, setMonth] = useState(props?.month);

  useEffect(() => {
    setDate(props?.date);
    setMonth(props?.month);
  }, [props?.date, props?.month]);

  return (
    <Wrapper>
      {props.color === "Grey" ? (
        <div className="bg-img-calendar-grey">
          <div className="calendar-text-date-grey">{date}</div>
          <div className="calendar-text-month-grey">{month}</div>
        </div>
      ) : (
        [
          props.color === "Green" ? (
            <div className="bg-img-calendar-green">
              <div className="calendar-text-date-green">{date}</div>
              <div className="calendar-text-month-green">{month}</div>
            </div>
          ) : (
            <div className="bg-img-calendar-red">
              <div className="calendar-text-date-red">{date}</div>
              <div className="calendar-text-month-red">{month}</div>
            </div>
          ),
        ]
      )}
    </Wrapper>
  );
};

export default CalendarDiv;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  .bg-img-calendar-grey {
    background-image: url(${CalendarGrey});
    /* Image doesn't repeat */
    background-repeat: no-repeat;
    /* This is what makes the background image rescale based on its container's size */
    background-size: contain;
    min-width: 32px;
    min-height: 32px;
  }
  .bg-img-calendar-red {
    background-image: url(${CalendarRed});
    /* Image doesn't repeat */
    background-repeat: no-repeat;
    /* This is what makes the background image rescale based on its container's size */
    background-size: contain;
    min-width: 32px;
    min-height: 32px;
  }
  .bg-img-calendar-green {
    background-image: url(${CalendarGreen});
    /* Image doesn't repeat */
    background-repeat: no-repeat;
    /* This is what makes the background image rescale based on its container's size */
    background-size: contain;
    min-width: 32px;
    min-height: 32px;
  }
  .calendar-text-date-red {
    margin-top: 13px;
    color: #c21e1e;
    font-size: 15px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      line-height: 12px;
      margin-top: 15px;
    }
  }
  .calendar-text-month-red {
    margin-top: 7.5px;
    color: #c21e1e;
    font-family: "robotoregular";
    font-size: 18px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
      line-height: 14px;
    }
  }
  .calendar-text-date-grey {
    margin-top: 13px;
    color: #7e7e7e;
    font-size: 15px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      line-height: 12px;
      margin-top: 15px;
    }
  }
  .calendar-text-month-grey {
    margin-top: 7.5px;
    color: #7e7e7e;
    font-family: "robotoregular";
    font-size: 18px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
      line-height: 14px;
    }
  }
  .calendar-text-date-green {
    margin-top: 13px;
    color: #1ec252;
    font-size: 15px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      line-height: 12px;
      margin-top: 15px;
    }
  }
  .calendar-text-month-green {
    margin-top: 7.5px;
    color: #1ec252;
    font-family: "robotoregular";
    font-size: 18px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
      line-height: 14px;
    }
  }
`;
